import React from 'react';
import { EditOutlined, CopyOutlined, DeleteOutlined } from '@ant-design/icons';
import ToolbarButton from './ToolbarButton';
import { RedirectIcon } from '../../../../assets/CustomIcons/RedirectIcon';
interface LinkMenuProps {
  editor: any;
  onOpenLink: () => void;
  onEditLink: () => void;
  onCopyLink: () => void;
  onDeleteLink: () => void;
}

const LinkMenu: React.FC<LinkMenuProps> = ({ editor, onOpenLink, onEditLink, onCopyLink, onDeleteLink }) => {
  const handleMenuClick = (e: React.MouseEvent) => {
    e.preventDefault();
    e.stopPropagation();
    editor.commands.focus();
  };

  const toolbarItems = [
    {
      title: 'Open Link',
      onClick: onOpenLink,
      icon: <RedirectIcon />,
    },
    {
      title: 'Edit Link',
      onClick: onEditLink,
      icon: <EditOutlined />,
    },
    {
      title: 'Copy Link',
      onClick: onCopyLink,
      icon: <CopyOutlined />,
    },
    {
      title: 'Delete Link',
      onClick: onDeleteLink,
      icon: <DeleteOutlined className="w-4" />,
    },
  ];

  return (
    <div
      className={`flex gap-2 p-2 border-b border-neutral-200 items-center h-6`}
      onClick={handleMenuClick}
      onMouseDown={(e) => {
        e.preventDefault();
        e.stopPropagation();
      }}
    >
      <React.Fragment key="link-menu">
        {toolbarItems.map((item, index) => (
          <>
            {index > 2 && <div className="w-px h-6 bg-neutral-300 mx-1" />}
            <ToolbarButton
              key={item.title}
              title={item.title}
              onClick={item.onClick}
              icon={item.icon}
              isLinkMenu={true}
            />
          </>
        ))}
      </React.Fragment>
    </div>
  );
};

export default LinkMenu;
